export default __webpack_public_path__ + "static/media/cute-cartoon-eyes-looking-right-15467.5a29a076.svg";